module.exports = "<map-component #Hmap [mapId]=\"'Hmap'\" [showZoom]=\"false\" [ShowSettingMenu]=\"false\" [showGeoCode]=\"false\" [showXYLabel]=\"false\" [AllowClusting]=\"false\"></map-component>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/mapPopup/map-popup.component.html
// module id = ../../../../../app/shared/components/mapPopup/map-popup.component.html
// module chunks = main